module.exports = __webpack_public_path__ + "img/env_2.2059b5c6.jpg";